var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t(
        '_web_error_page_message',
        "The page you're looking for could not be found."
      ))+"\n  ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('_web_error_page_message_link', 'Go back to the home page')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }